export function scrollToElementBottom(element: HTMLElement) {
  const scrollArea = document.querySelector('#scroll-area')!;
  const rects = element.getBoundingClientRect();
  const scrollTop = scrollArea.getBoundingClientRect().top;

  if (rects.bottom >= scrollArea.clientHeight + scrollTop) {
    scrollArea.scrollTo({ top: 99999, behavior: 'smooth' })
  }
}
